module.exports = __webpack_public_path__ + "img/arrow_up_2.048c1d2d.svg";